/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/issueCredential.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { ISSUE_SELFATTESTED_CREDENTIAL } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IIssueCredentialMethods extends IPluginMethodMap {
  getIssueCredential(args: any): Promise<any>;
}

export interface IssueCredentialProps {
  formData: any;
  templateId: string;
  userSelected: any[];
  issueType: "public" | "private";
  emailIssue: boolean;
  walletIssue: boolean;
  evidence?: any;
}

export class IssueCredentialService implements IAgentPlugin {
  readonly methods: IIssueCredentialMethods;

  constructor() {
    this.methods = {
      getIssueCredential: this.getIssueCredential.bind(this),
    };
  }

  async getIssueCredential(args: IssueCredentialProps) {
    console.log(`args in issue credential`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    let _evidence =
      Array.isArray(args?.evidence) &&
      args?.evidence.map((item) => {
        return {
          id: item?.base64,
          evidenceDocument: item?.name,
          evidenceDocumentType: item?.type,
        };
      });

    try {
      if (client) {
        const res = await client.mutate({
          mutation: ISSUE_SELFATTESTED_CREDENTIAL,
          variables: {
            credentialTemplateId: args?.templateId,
            visiblity: config?.visiblity,
            credentialContent: args?.formData,
            sendEmail: args?.emailIssue,
            sendPn: args?.walletIssue,
            evidence: this.getEvidence(args?.formData, _evidence),
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.issueSelfAttestedCredential) {
          console.log(`table data`, res);
          return {
            ...res?.data?.issueSelfAttestedCredential,
            email: args?.userSelected,
            notification: notification?.issueSelfAttestedCredential,
          };
        }
      }
    } catch (err: any) {
      console.log("error in issue credential", err?.message);
    }
  }

  private getEvidence(formData: any, evidence:any[]) {
    console.log(`formData in get Evidence`, formData);
    let _evidence: any = [];
    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value) && value?.length > 0) {
        value.forEach(ele => {
          if (ele?.type && ele?.file) {
            _evidence.push({
              evidenceDocumentType: ele?.type,
              evidenceDocument: ele?.name,
              id: ele?.base64,
            })
          }
        })
      }
    })
    if(Array.isArray(evidence) && evidence?.length > 0 ){
      _evidence = [..._evidence, ...evidence];
    }
    return _evidence;
  }
}
